module.exports = __webpack_public_path__ + "media/Goldberg_Variations_01_Aria.1087ac0d.ogg";